export const colorDark = '#000716';
export const colorGray = '#868686';
